import React from 'react';
import PropTypes from 'prop-types';

const RelativesTableDisclaimer = ({ type }) => (
    <div className="pp-bottomText">
        <p className="pp-bottomText__progenyInfo">
            {type} in <strong>bold</strong> are stakes placed.
            Trainer listed is trainer with whom horse achieved highest RPR.
        </p>
        <p className="pp-bottomText__progenyInfo">
            Details of horses trained outside GB and Ireland or born prior to 1986 may be
            incomplete.
        </p>
    </div>
);

RelativesTableDisclaimer.propTypes = {
    type: PropTypes.string.isRequired,
};

export default RelativesTableDisclaimer;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/relativesTable/RelativesTableDisclaimer.jsx